import axios from 'axios'

import {
    GET_THREAD_DETAILS_START,
    GET_THREAD_DETAILS_SUCCESS,
    GET_THREAD_DETAILS_FAIL,
    GET_DEALERSHIP_DETAILS_START,
    GET_DEALERSHIP_DETAILS_SUCCESS,
    GET_DEALERSHIP_DETAILS_FAIL,
    UPDATE_ANSWER_MODE_START,
    UPDATE_ANSWER_MODE_SUCCESS,
    UPDATE_ANSWER_MODE_FAIL,
    GET_USER_DETAILS_START,
    GET_USER_DETAILS_SUCCESS,
    GET_USER_DETAILS_FAIL,
    UPDATE_SUBSCRIPTION_START,
    UPDATE_SUBSCRIPTION_SUCCESS,
    UPDATE_SUBSCRIPTION_FAIL,
    UPDATE_INTEREST_STATUS_START,
    UPDATE_INTEREST_STATUS_SUCCESS,
    UPDATE_INTEREST_STATUS_FAIL,
    GET_ELEAD_URL_START,
    GET_ELEAD_URL_SUCCESS,
    GET_ELEAD_URL_FAIL,
    GENERATE_ANSWER_START,
    GENERATE_ANSWER_SUCCESS,
    GENERATE_ANSWER_FAIL,
    GET_USER_SUBSCRIPTION_START,
    GET_USER_SUBSCRIPTION_SUCCESS,
    GET_USER_SUBSCRIPTION_FAIL,
} from './constants'

export const getThreadDetails = (accountId, threadId) => dispatch => {
    dispatch({
        type: GET_THREAD_DETAILS_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        url: `/api/vehicles/${threadId}?accountId=${accountId}`,
        method: 'get',
        headers: { authorization },
    })
        .then(res => {
            dispatch({
                type: GET_THREAD_DETAILS_SUCCESS,
                payload: res.data,
            })
        })
        .catch(() => {
            dispatch({
                type: GET_THREAD_DETAILS_FAIL,
            })
        })
}

export const getDealershipDetails = dealer => dispatch => {
    dispatch({
        type: GET_DEALERSHIP_DETAILS_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        url: `/api/dealers/${dealer}`,
        method: 'get',
        headers: { authorization },
    })
        .then(res => {
            dispatch({
                type: GET_DEALERSHIP_DETAILS_SUCCESS,
                payload: res.data,
            })
        })
        .catch(() => {
            dispatch({
                type: GET_DEALERSHIP_DETAILS_FAIL,
            })
        })
}

export const updateAnswersMode = (accountId, mode) => dispatch => {
    dispatch({
        type: UPDATE_ANSWER_MODE_START,
    })

    axios({
        url: '/api/account',
        method: 'put',
        data: {
            accountId,
            settings: {
                AnswerMode: mode,
            },
        },
    })
        .then(() => {
            dispatch({
                type: UPDATE_ANSWER_MODE_SUCCESS,
            })
        })
        .catch(() => {
            dispatch({
                type: UPDATE_ANSWER_MODE_FAIL,
            })
        })
}

export const getSubscriptionStatus = (accountId, contactParams) => dispatch => {
    const { email, phone } = contactParams
    dispatch({
        type: GET_USER_SUBSCRIPTION_START,
    })
    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )
    const userDetailsPromiseEmail = axios({
        url: `/api/operators/users?accountId=${accountId}&userId=${email}`,
        method: 'get',
        headers: { authorization },
    })

    const userDetailsPromiseSms = axios({
        url: `/api/operators/users?accountId=${accountId}&userId=${phone}`,
        method: 'get',
        headers: { authorization },
    })

    Promise.all([userDetailsPromiseEmail, userDetailsPromiseSms])
        .then(responses => {
            const payload = []

            responses.forEach(res => {
                const { data } = res
                payload.push(data)
            })

            dispatch({
                type: GET_USER_SUBSCRIPTION_SUCCESS,
                payload,
            })
        })
        .catch(() => {
            dispatch({
                type: GET_USER_SUBSCRIPTION_FAIL,
            })
        })
}

export const getUserData = (accountId, userId, threadId, convoId) => dispatch => {
    dispatch({
        type: GET_USER_DETAILS_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    // const userDetailsPromise = axios({
    //  url: `/api/operators/users?accountId=${accountId}&userId=${userId}`,
    //  method: 'get',
    //  headers: { authorization },
    // })

    const interestStatusPromise = axios({
        url: '/api/interest-status',
        method: 'get',
        params: { convoId },
        headers: { authorization },
    })

    Promise.all([interestStatusPromise])
        .then(responses => {
            let payload = {}

            responses.forEach(res => {
                const { data } = res

                payload = { ...payload, ...data }
            })

            dispatch({
                type: GET_USER_DETAILS_SUCCESS,
                payload,
            })
        })
        .catch(() => {
            dispatch({
                type: GET_USER_DETAILS_FAIL,
            })
        })
}

export const updateSubscription = data => dispatch => {
    console.log('ASDASDOUHWDOIUHQOW')
    console.log('ASDASDOUHWDOIUHQOW')
    console.log('ASDASDOUHWDOIUHQOW')
    console.log(data)
    dispatch({
        type: UPDATE_SUBSCRIPTION_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        url: '/api/operators/users',
        method: 'post',
        headers: { authorization },
        data,
    })
        .then(() => {
            dispatch({
                type: UPDATE_SUBSCRIPTION_SUCCESS,
                payload: data.unsubscribe,
            })
        })
        .catch(() => {
            dispatch({
                type: UPDATE_SUBSCRIPTION_FAIL,
            })
        })
}

export const updateInterestStatus = data => dispatch => {
    dispatch({
        type: UPDATE_INTEREST_STATUS_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        url: '/api/interest-status',
        method: 'put',
        headers: { authorization },
        data,
    })
        .then(() => {
            dispatch({
                type: UPDATE_INTEREST_STATUS_SUCCESS,
                payload: data.status,
            })
        })
        .catch(() => {
            dispatch({
                type: UPDATE_INTEREST_STATUS_FAIL,
            })
        })
}

export const getEleadURL = leadId => dispatch => {
    dispatch({
        type: GET_ELEAD_URL_START,
    })

    axios({
        url: '/api/links/elead',
        method: 'post',
        data: { leadId },
    })
        .then(res => {
            // console.log(res.data)
            dispatch({
                type: GET_ELEAD_URL_SUCCESS,
                payload: res.data.resourceUrl,
            })
        })
        .catch(() => {
            dispatch({
                type: GET_ELEAD_URL_FAIL,
            })
        })
}

export const generateAnswer = item => dispatch => {
    dispatch({
        type: GENERATE_ANSWER_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        url: '/api/conversations/generate-answer',
        method: 'post',
        headers: { authorization },
        data: item,
    })
        .then(() => {
            dispatch({
                type: GENERATE_ANSWER_SUCCESS,
            })
        })
        .catch(() => {
            dispatch({
                type: GENERATE_ANSWER_FAIL,
            })
        })
}
